import { render, staticRenderFns } from "./CurrentNotes.vue?vue&type=template&id=2e5cc672&scoped=true&"
import script from "./CurrentNotes.vue?vue&type=script&lang=ts&"
export * from "./CurrentNotes.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentNotes.vue?vue&type=style&index=0&id=2e5cc672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5cc672",
  null
  
)

export default component.exports